const guiColors = {
    'motion-primary': '#00a832',
    'motion-primary-transparent': '#00a832e6',
    'motion-tertiary': '#007a24',

    'looks-secondary': '#00a832',
    'looks-transparent': '#00a83259',
    'looks-light-transparent': '#00a83226',
    'looks-secondary-dark': 'hsla(138, 100%, 24%, 1)',

    'extensions-primary': 'hsla(138, 100%, 33%, 1)',
    'extensions-tertiary': 'hsla(138, 100%, 18%, 1)',
    'extensions-transparent': 'hsla(138, 100%, 33%, 0.35)',
    'extensions-light': 'hsla(138, 60%, 75%, 1)',

    'drop-highlight': '#00ff41',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'rgba(0, 20, 0, 0.85) 0%, ' +
        'rgba(0, 59, 0, 0.8) 40%, ' +
        'rgba(0, 143, 17, 0.75) 80%, ' +
        'rgba(0, 255, 65, 0.7) 100%)'
};

const blockColors = {
    checkboxActiveBackground: '#00a832',
    checkboxActiveBorder: '#00ff41'
};

export {
    guiColors,
    blockColors
};
